import React from 'react';

const Cta = () => {
  return (
    <section className="py-20 px-4 bg-[#E1F5FE]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#03ADED]">
          ¿Listo para digitalizar tu negocio?
        </h2>
        <p className="text-xl mb-8 text-gray-600">
          Únete a más de 200 negocios peruanos que ya optimizaron sus operaciones con YupiSoft.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="https://wa.me/51972843376?text=Hola%20YupiSoft,%20quiero%20agendar%20una%20cita" className="bg-[#03ADED]  text-white font-bold py-3 px-8 rounded-lg transition-all transform hover:scale-105">
            Agendar cita con especialista
          </a>
          <a 
            href="https://wa.me/51972843376?text=Hola%20YupiSoft,%20quiero%20más%20información" 
            className="bg-white text-[#03ADED] border-2 border-[#03ADED]  font-bold py-3 px-8 rounded-lg transition-all transform hover:scale-105"
          >
            WhatsApp +51 972 843 376
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;